parentChunkLoadingFunction